"use client";

import dynamic from "next/dynamic";

import { useAnalysisSidebar } from "@/providers/analysis-sidebar-provider";

const PoolAnalysisSidebar = dynamic(
	() => import("@/feature/pool-analysis/components/PoolAnalysisSidebar"),
	{
		ssr: false,
		loading: () => (
			<div
				className="fixed inset-y-0 right-0 z-40 w-full max-w-lg animate-pulse bg-secondary/40 backdrop-blur-[1px]"
				aria-hidden
			/>
		),
	},
);

export default function SidebarDefault() {
	const { openPool, closeAnalysis } = useAnalysisSidebar();
	if (!openPool) {
		return null;
	}

	return (
		<PoolAnalysisSidebar
			key={`${openPool.network}:${openPool.pool}`}
			network={openPool.network}
			poolAddress={openPool.pool}
			onClose={closeAnalysis}
		/>
	);
}
